import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import BrandLogo from './BrandLogo';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      {/* Main Header */}
      <header className="bg-white border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <a href="/" className="flex items-center" aria-label="myHometown Direct Care home">
                <BrandLogo height={40} />
              </a>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              <a href="#benefits" className="text-gray-700 hover:text-red-600 transition-colors">
                Why Us?
              </a>
              <a href="#features" className="text-gray-700 hover:text-red-600 transition-colors">
                Solutions
              </a>
              <a href="#resources" className="text-gray-700 hover:text-red-600 transition-colors">
                Resources
              </a>
              <a href="#pricing" className="text-gray-700 hover:text-red-600 transition-colors">
                Pricing
              </a>
              <a href="#testimonials" className="text-gray-700 hover:text-red-600 transition-colors">
                Testimonials
              </a>
            </nav>

            {/* CTA Button */}
            <div className="hidden md:flex items-center gap-4">
              <a href="/login" className="text-gray-700 hover:text-red-600 transition-colors font-medium">
                Sign In
              </a>
              <a href="/staff-login" className="text-red-600 hover:text-red-700 transition-colors font-medium border border-red-600 px-4 py-2 rounded-lg hover:bg-red-50">
                Clinic Staff Login
              </a>
              <a href="/signup">
                <Button className="bg-red-600 hover:bg-red-700 text-white rounded-full px-6">
                  Get Started
                </Button>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t bg-white">
            <div className="px-4 py-4 space-y-4">
              <a href="#features" className="block text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Solutions</a>
              <a href="#benefits" className="block text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Why Us?</a>
              <a href="#testimonials" className="block text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Testimonials</a>
              <a href="#resources" className="block text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Resources</a>
              <a href="#pricing" className="block text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Pricing</a>
              <a href="/login" className="block text-gray-700 hover:text-red-600 font-medium">Sign In</a>
              <a href="/staff-login" className="block text-red-600 hover:text-red-700 font-medium border border-red-600 px-4 py-2 rounded-lg text-center">Clinic Staff Login</a>
              <a href="/signup" className="block">
                <Button className="w-full bg-red-600 hover:bg-red-700 text-white rounded-full">
                  Get Started
                </Button>
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;